import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiFacebook, FiInstagram } from "react-icons/fi";
import { siteConfig } from "../Datas/productData";
import "../css/footer.scss";

function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (event) => {
    event.preventDefault();
    if (!email.trim()) return;
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="site-footer__newsletter" aria-labelledby="newsletter-title">
        <div>
          <span className="eyebrow">From the workshop</span>
          <h2 id="newsletter-title">The item of the week, straight to your inbox.</h2>
          <p>One considered product, a closer look at the cloth, and 20% off for seven days.</p>
        </div>
        {subscribed ? (
          <p className="site-footer__newsletter-success" role="status">
            You’re on the list. Watch your inbox.
          </p>
        ) : (
          <form onSubmit={handleSubscribe}>
            <label className="sr-only" htmlFor="footer-email">Email address</label>
            <input
              id="footer-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Email address"
              required
            />
            <button type="submit" aria-label="Subscribe">
              Subscribe <FiArrowRight aria-hidden="true" />
            </button>
          </form>
        )}
      </section>

      <div className="site-footer__main">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo">{siteConfig.logo.text}</Link>
          <p>{siteConfig.description}</p>
          <p>Get dressed. Get moving. Let the cloth tell the story.</p>
          <div className="site-footer__social">
            <a href={siteConfig.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram">
              <FiInstagram aria-hidden="true" />
            </a>
            <a href={siteConfig.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook">
              <FiFacebook aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="site-footer__links">
          <div>
            <h3>Main links</h3>
            <Link to="/">Home</Link>
            <Link to="/shop">Shop</Link>
            <Link to="/shop?new=true">New arrivals</Link>
            <Link to="/about">About</Link>
            <Link to="/shop?sale=true">Sale</Link>
          </div>
          <div>
            <h3>Shop</h3>
            <Link to="/shop?category=Jeans">Raw selvedge denim</Link>
            <Link to="/shop?category=Pants">Other bottoms</Link>
            <Link to="/shop?category=Tops">Tops</Link>
            <Link to="/shop?category=Jackets">Jackets</Link>
            <Link to="/shop?category=Accessories">Accessories</Link>
          </div>
          <div>
            <h3>Customer care</h3>
            <Link to="/shipping">Shipping</Link>
            <Link to="/returns">Returns &amp; exchanges</Link>
            <Link to="/contact">Contact</Link>
            <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
          </div>
          <div>
            <h3>Quick info</h3>
            <Link to="/about">Raw denim</Link>
            <Link to="/about">Our story</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms &amp; conditions</Link>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.</span>
        <span>{siteConfig.contact.address}</span>
      </div>
    </footer>
  );
}

export default Footer;
